import getTimeSince from './getTimeSince.js';

const getHumanMessageDate = (dateString) => {
  let date = new Date(dateString.replace(' ', 'T') + 'Z');
  date = new Date() - date < 0 ? new Date() : date;
  return getTimeSince(date);
};

export default getHumanMessageDate;
